import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import ConfirmDialog from 'components/ConfirmDialog';
import { archiveSupply, fetchImpact, purgeSupply } from 'store/suppliesArchive';
import { archiveCopy } from '../../helpers/archive';
import useStyles from './styles';

const ImpactItem = ({ name, colorOrNumber, manufacturerName }) => {
  const classes = useStyles();
  const details = [
    colorOrNumber && ['Color/Number', colorOrNumber],
    manufacturerName && ['Manufacturer', manufacturerName],
  ].filter(Boolean);

  return (
    <div>
      <span className={classes.value}>{name}</span>
      {!!details.length && (
        <>
          {' ('}
          {details.map(([label, value], index) => (
            <React.Fragment key={label}>
              {index > 0 && ', '}
              {`${label}: `}
              <span className={classes.value}>{value}</span>
            </React.Fragment>
          ))}
          {')'}
        </>
      )}
    </div>
  );
};

const ArchiveDialog = ({ entity, item, action = 'archive', onClose, onDone, setSnackbar }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [impact, setImpact] = useState(null);
  const isPurge = action === 'purge';

  useEffect(() => {
    let isMounted = true;
    dispatch(fetchImpact(entity, item._id, action))
      // the impact only enriches the copy, so a failed lookup must not block the action
      .then((data) => isMounted && setImpact(data))
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, [entity, item._id, action]);

  const onSubmit = async () => {
    try {
      const result = await dispatch(
        isPurge ? purgeSupply(entity, item._id) : archiveSupply(entity, item._id)
      );
      setSnackbar({ text: isPurge ? 'Successfully Deleted!' : 'Successfully Archived!', type: 'success' });
      // purge answers with just { ok }, so the impact fetched above carries what else went with it
      onDone({ ...impact, ...result });
    } catch (error) {
      setSnackbar({ text: error.message, type: 'error' });
    }
    onClose();
  };

  const { text, sections } = archiveCopy(entity, action, impact);
  const description = sections.length ? (
    <div className={classes.sections}>
      {sections.map(({ title, items }) => (
        <React.Fragment key={title}>
          {title}
          {items.map((item) => (
            <ImpactItem key={item._id} {...item} />
          ))}
        </React.Fragment>
      ))}
    </div>
  ) : undefined;

  return (
    <ConfirmDialog
      isOpen
      onClose={onClose}
      onSubmit={onSubmit}
      text={text}
      description={description}
      cancelBtn="Cancel"
      confirmBtn={isPurge ? 'Delete' : 'Archive'}
      disableEscape
      loadingOnSubmit
      widthVariant="auto"
    />
  );
};

export default ArchiveDialog;
